import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import CompanyOverview from "./sections/CompanyOverview";
import MissionVision from "./sections/MissionVision";
import LeadershipTeam from "./sections/LeadershipTeam";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <CompanyOverview />
      <MissionVision />
      <LeadershipTeam />
      <Footer />
    </div>;
}